//Reset data
export const RESET = "CONVERSATION_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CONVERSATION_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CONVERSATION_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CONVERSATION_LIST_SET_HIDE_LOADING"

//Pagination

export const SET_PAGINATION ="CONVERSATION_LIST_SET_PAGINATION"

//Message
export const SET_MESSAGE = "CONVERSATION_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "CONVERSATION_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CONVERSATION_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CONVERSATION_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CONVERSATION_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CONVERSATION_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CONVERSATION_LIST_SET_ITEMS"
export const SET_APPEND_ITEMS = "CONVERSATION_LIST_SET_APPEND_ITEMS"
export const SET_CURRENT_ITEM = "CONVERSATION_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CONVERSATION_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CONVERSATION_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CONVERSATION_LIST_SET_HIDE_MODAL"

